import apiHeader from '@/helpers/apiHeader';

const managePermissionService = {
  listAll() {
    return apiHeader.get('manage-account/manage-role/permissions/all');
  },
};

export default managePermissionService;
